import { Metrics } from './metrics';
export const logMediaPlayerErrorMetric = ({
  errorType,
  source,
  requestedRecordingUrlUpdate,
  status = undefined
}) => {
  Metrics.counter('media-player-error', {
    error_type: errorType,
    source: source || 'unknown',
    requested_recording_url_update: `${requestedRecordingUrlUpdate}`,
    status: status || 'unknown'
  }).increment();
};